module.exports = __webpack_public_path__ + "static/media/bill_payment.782edd3e.svg";